/**
 * Достаёт имя файла из пути/URL вида …/v1/images/{filename} (нужно для retainImageFilenames при редактировании).
 */
export function imageFilenameFromApiUrl(urlOrPath) {
    if (!urlOrPath || typeof urlOrPath !== 'string') return ''
    try {
        const pathOnly = urlOrPath.startsWith('http')
            ? new URL(urlOrPath).pathname
            : urlOrPath.split('?')[0]
        const m = pathOnly.match(/\/v1\/images\/([^/?#]+)/)
        return m ? decodeURIComponent(m[1]) : ''
    } catch {
        return ''
    }
}

/**
 * Собирает абсолютный URL картинки товара: приоритет imageUrls из API, иначе /v1/images/{filename}.
 */
export function itemImageSrc(item, index = 0) {
    const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
    if (!item) return '';
    const urls = item.imageUrls;
    if (urls && urls.length > index) {
        const u = urls[index];
        if (u.startsWith('http')) return u;
        return base + (u.startsWith('/') ? u : '/' + u);
    }
    const img = item.images && item.images[index];
    if (!img) return '';
    const name = img.filename || img.filePath;
    if (!name) return '';
    if (name.startsWith('http')) return name;
    const file = name.includes('/') ? name.split('/').pop() : name;
    return `${base}/v1/images/${encodeURIComponent(file)}`;
}
